import { Entity, LiveData } from '@toeverything/infra';
import type { Location } from 'history';
import { Observable, switchMap } from 'rxjs';

import type { WorkbenchService } from '../../workbench';

export class Navigator extends Entity {
  constructor(private readonly workbenchService: WorkbenchService) {
    super();
  }

  private readonly history$ = this.workbenchService.workbench.activeView$.map(
    view => view?.history
  );

  private readonly location$ = LiveData.from(
    this.history$.pipe(
      switchMap(
        history =>
          history
            ? new Observable<{ index: number; entries: Location[] }>(subscriber => {
                subscriber.next({ index: history.index, entries: history.entries });
                return history.listen(() => {
                  subscriber.next({
                    index: history.index,
                    entries: history.entries,
                  });
                });
              })
            : new Observable<{ index: number; entries: Location[] }>(subscriber => {
                subscriber.next({ index: 0, entries: [] });
              })
      )
    ),
    { index: 0, entries: [] }
  );

  readonly backable$ = this.location$.map(
    ({ index, entries }: { index: number; entries: Location[] }) => index > 0 && entries.length > 1
  );

  readonly forwardable$ = this.location$.map(
    ({ index, entries }: { index: number; entries: Location[] }) => index < entries.length - 1
  );

  back() {
    window.history.back();
  }

  forward() {
    window.history.forward();
  }
}
